import { dequal } from 'dequal'
import { ProductBundle } from '@typesApp/Product'

export const hasEligibleProductsChanged = (
  currentProducts: ProductBundle[] | undefined,
  updatedProducts: ProductBundle[] | undefined
): boolean => {
  if (currentProducts?.length !== updatedProducts?.length) {
    return true
  }

  const left = currentProducts?.map(p => getBundleNonDecorated(p))
  const right = updatedProducts?.map(p => getBundleNonDecorated(p))

  return !dequal(left, right)
}

const getBundleNonDecorated = (bundle: ProductBundle): ProductBundle => {
  // ignore decorated fields that may not exist in both source and target
  const { includedInPrescription, bundleId, claimable, variantsAvailable, ...rest } = bundle

  // ignore coloredContactLens as it comes from B/E even for GL
  const { left, right } = rest?.prescription ?? {}
  const { coloredContactLens: coloredContactLensLeft, colour: colourLeft, ...leftOptions } = left?.options ?? {}
  const { coloredContactLens: coloredContactLensRight, colour: colourRight, ...rightOptions } = right?.options ?? {}

  const copy = {
    ...rest,

    prescription: {
      left: leftOptions,
      right: rightOptions,
    },

    // ignore decorated attributes and price information
    cartProducts: bundle.cartProducts.map(product => {
      const { insuranceEligible, price, packSize, conscat, ...rawProduct } = product
      return rawProduct
    }),
  } as ProductBundle

  return copy
}
